module.exports = __webpack_public_path__ + "img/hair_front_female_frizzy_side_part.99608aeb.png";